import { atom } from 'jotai';

export const clerkServiceErrorVisibleAtom = atom(false);
